import React, { useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import atslogo from "../../src/assets/images/ats-logo.png"

const ConsentFile = () => {
  document.title = "ATS - Consent"
  const { token1 } = useParams()
  const [consentResponse, setConsentResponse] = React.useState(false)
  const [loadingType, setLoadingType] = useState(null)
  const handleConsent = async type => {
    setLoadingType(type)

    try {
      const response = await axios.post(
        `api/v1/update-consent/${token1}/?response=${type}`
      )

      if (response.status === 200) {
        setLoadingType(null)
        Swal.fire({
          icon: type === "yes" ? "success" : "info",
          title: type === "yes" ? "Thank You!" : "Consent Declined",
          text:
            type === "yes"
              ? "You have given consent successfully."
              : "You have declined consent.",
          confirmButtonText: "OK",
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          setConsentResponse(true)
        })
      }
    } catch (error) {
      setLoadingType(null)

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
      })
    }
  }

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div
        className="card shadow-lg border-0 rounded-4"
        style={{ maxWidth: "480px", width: "100%" }}
      >
        <div className="card-body p-3 p-md-5 text-center">
          <div className="mb-3">
            <img src={atslogo} alt="logo" style={{ width: "250px" }} />
          </div>

          {!consentResponse ? (
            <>
              <h4 className="text-primary mb-3" style={{ fontWeight: 500 }}>
                Consent to Receive Communication from TalentScan
              </h4>
              <p className="text-muted mb-4">
                By confirming below, you consent to receive phone calls, SMS,
                WhatsApp messages, and/or emails from TalentScan regarding our
                products, services, and updates.
              </p>

              <div className="d-flex flex-column gap-3 align-items-center">
                <button
                  className="btn btn-primary w-75 py-2 fw-semibold shadow-sm"
                  onClick={() => handleConsent("yes")}
                  disabled={loadingType !== null}
                >
                  {loadingType === "yes" ? "Please wait..." : "I Consent"}
                </button>
                <button
                  className="btn btn-outline-danger w-75 py-2 fw-semibold"
                  onClick={() => handleConsent("no")}
                  disabled={loadingType !== null}
                >
                  {loadingType === "no" ? "Please wait..." : "I Do Not Consent"}
                </button>
              </div>
            </>
          ) : (
            <div className="mt-4">
              <h5 className="text-success">Thank you for your response.</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ConsentFile
